import { render, staticRenderFns } from "./LeccionA4.vue?vue&type=template&id=084441ce&"
import script from "./LeccionA4.vue?vue&type=script&lang=js&"
export * from "./LeccionA4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports